import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
// tslint:disable-next-line:max-line-length
import { EducationMean, LearningActionType, LearningPhase, EvaluationTool, EvaluationStrategy, TeachingStrategy, GpClassification, LearningClassification, PlansSubjectsSettings, } from '../../_models';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class SubjectsSettingsService {
    private apiUrl = `${environment.apiUrl}/SubjectsSettings`;

    constructor(private http: HttpClient) {
    }

    getPlansSubjectsSettings(): Observable<PlansSubjectsSettings> {
        return this.http.get<PlansSubjectsSettings>(`${this.apiUrl}/GetPlansSubjectsSettings`);
    }

    //#region GpClassification
    getAllGpClassifications(): Observable<GpClassification[]> {
        return this.http.get<GpClassification[]>(`${this.apiUrl}/GetAllGpClassifications`);
    }

    addGpClassification(gpClassification: GpClassification): Observable<GpClassification> {
        return this.http.post<GpClassification>(`${this.apiUrl}/AddGpClassification`, gpClassification);
    }

    updateGpClassification(gpClassification: GpClassification): Observable<GpClassification> {
        return this.http.put<GpClassification>(`${this.apiUrl}/UpdateGpClassification`, gpClassification);
    }

    deleteGpClassification(gpClassificationId: number): Observable<GpClassification> {
        return this.http.delete<GpClassification>(`${this.apiUrl}/DeleteGpClassification/${gpClassificationId}`);
    }
    //#endregion

    //#region EducationMean
    getAllEducationMeans(): Observable<EducationMean[]> {
        return this.http.get<EducationMean[]>(`${this.apiUrl}/GetAllEducationMeans`);
    }

    getTopEducationMeansWithInnerItems(): Observable<EducationMean[]> {
        return this.http.get<EducationMean[]>(`${this.apiUrl}/GetTopEducationMeansWithInnerItems`);
    }

    addEducationMean(educationMean: EducationMean): Observable<EducationMean> {
        return this.http.post<EducationMean>(`${this.apiUrl}/AddEducationMean`, educationMean);
    }

    updateEducationMean(educationMean: EducationMean): Observable<EducationMean> {
        return this.http.put<EducationMean>(`${this.apiUrl}/UpdateEducationMean`, educationMean);
    }

    deleteEducationMean(educationMeanId: number): Observable<EducationMean> {
        return this.http.delete<EducationMean>(`${this.apiUrl}/DeleteEducationMean/${educationMeanId}`);
    }
    //#endregion


    //#region TeachingStrategy
    getAllTeachingStrategies(): Observable<TeachingStrategy[]> {
        return this.http.get<TeachingStrategy[]>(`${this.apiUrl}/GetAllTeachingStrategies`);
    }

    addTeachingStrategy(teachingStrategy: TeachingStrategy): Observable<TeachingStrategy> {
        return this.http.post<TeachingStrategy>(`${this.apiUrl}/AddTeachingStrategy`, teachingStrategy);
    }

    updateTeachingStrategy(teachingStrategy: TeachingStrategy): Observable<TeachingStrategy> {
        return this.http.put<TeachingStrategy>(`${this.apiUrl}/UpdateTeachingStrategy`, teachingStrategy);
    }

    deleteTeachingStrategy(teachingStrategyId: number): Observable<TeachingStrategy> {
        return this.http.delete<TeachingStrategy>(`${this.apiUrl}/DeleteTeachingStrategy/${teachingStrategyId}`);
    }
    //#endregion


    //#region EvaluationStrategy
    getAllEvaluationStrategies(): Observable<EvaluationStrategy[]> {
        return this.http.get<EvaluationStrategy[]>(`${this.apiUrl}/GetAllEvaluationStrategies`);
    }

    getTopEvaluationStrategies(): Observable<EvaluationStrategy[]> {
        return this.http.get<EvaluationStrategy[]>(`${this.apiUrl}/GetTopEvaluationStrategies`);
    }

    getTopEvaluationStrategiesWithInnerItems(): Observable<EvaluationStrategy[]> {
        return this.http.get<EvaluationStrategy[]>(`${this.apiUrl}/GetTopEvaluationStrategiesWithInnerItems`);
    }

    addEvaluationStrategy(evaluationStrategy: EvaluationStrategy): Observable<EvaluationStrategy> {
        return this.http.post<EvaluationStrategy>(`${this.apiUrl}/AddEvaluationStrategy`, evaluationStrategy);
    }

    updateEvaluationStrategy(evaluationStrategy: EvaluationStrategy): Observable<EvaluationStrategy> {
        return this.http.put<EvaluationStrategy>(`${this.apiUrl}/UpdateEvaluationStrategy`, evaluationStrategy);
    }

    deleteEvaluationStrategy(evaluationStrategyId: number): Observable<EvaluationStrategy> {
        return this.http.delete<EvaluationStrategy>(`${this.apiUrl}/DeleteEvaluationStrategy/${evaluationStrategyId}`);
    }
    //#endregion


    //#region EvaluationTool
    getAllEvaluationTools(): Observable<EvaluationTool[]> {
        return this.http.get<EvaluationTool[]>(`${this.apiUrl}/GetAllEvaluationTools`);
    }

    addEvaluationTool(evaluationTool: EvaluationTool): Observable<EvaluationTool> {
        return this.http.post<EvaluationTool>(`${this.apiUrl}/AddEvaluationTool`, evaluationTool);
    }

    updateEvaluationTool(evaluationTool: EvaluationTool): Observable<EvaluationTool> {
        return this.http.put<EvaluationTool>(`${this.apiUrl}/UpdateEvaluationTool`, evaluationTool);
    }

    deleteEvaluationTool(evaluationToolId: number): Observable<EvaluationTool> {
        return this.http.delete<EvaluationTool>(`${this.apiUrl}/DeleteEvaluationTool/${evaluationToolId}`);
    }
    //#endregion


    //#region LearningPhase
    getAllLearningPhases(): Observable<LearningPhase[]> {
        return this.http.get<LearningPhase[]>(`${this.apiUrl}/GetAllLearningPhases`);
    }

    addLearningPhase(learningPhase: LearningPhase): Observable<LearningPhase> {
        return this.http.post<LearningPhase>(`${this.apiUrl}/AddLearningPhase`, learningPhase);
    }

    updateLearningPhase(learningPhase: LearningPhase): Observable<LearningPhase> {
        return this.http.put<LearningPhase>(`${this.apiUrl}/UpdateLearningPhase`, learningPhase);
    }

    deleteLearningPhase(learningPhaseId: number): Observable<LearningPhase> {
        return this.http.delete<LearningPhase>(`${this.apiUrl}/DeleteLearningPhase/${learningPhaseId}`);
    }
    //#endregion


    //#region LearningActionType
    getAllLearningActionTypes(): Observable<LearningActionType[]> {
        return this.http.get<LearningActionType[]>(`${this.apiUrl}/GetAllLearningActionTypes`);
    }

    addLearningActionType(learningActionType: LearningActionType): Observable<LearningActionType> {
        return this.http.post<LearningActionType>(`${this.apiUrl}/AddLearningActionType`, learningActionType);
    }

    updateLearningActionType(learningActionType: LearningActionType): Observable<LearningActionType> {
        return this.http.put<LearningActionType>(`${this.apiUrl}/UpdateLearningActionType`, learningActionType);
    }

    deleteLearningActionType(learningActionTypeId: number): Observable<LearningActionType> {
        return this.http.delete<LearningActionType>(`${this.apiUrl}/DeleteLearningActionType/${learningActionTypeId}`);
    }
    //#endregion


    //#region LearningClassification
    getAllLearningClassifications(): Observable<LearningClassification[]> {
        return this.http.get<LearningClassification[]>(`${this.apiUrl}/GetAllLearningClassifications`);
    }

    getTopLearningClassificationsWithInnerItems(): Observable<LearningClassification[]> {
        return this.http.get<LearningClassification[]>(`${this.apiUrl}/GetTopLearningClassificationsWithInnerItems`);
    }

    addLearningClassification(learningClassification: LearningClassification): Observable<LearningClassification> {
        return this.http.post<LearningClassification>(`${this.apiUrl}/AddLearningClassification`, learningClassification);
    }

    updateLearningClassification(learningClassification: LearningClassification): Observable<LearningClassification> {
        return this.http.put<LearningClassification>(`${this.apiUrl}/UpdateLearningClassification`, learningClassification);
    }

    deleteLearningClassification(learningClassificationId: number): Observable<LearningClassification> {
        return this.http.delete<LearningClassification>(`${this.apiUrl}/DeleteLearningClassification/${learningClassificationId}`);
    }
    //#endregion

}

